import { VimeoFrame } from "src/utils/fw"
import { auditoriumCloseDate } from "../utils"

function column(left, top = 7.7, width = 28.3, heights = [3.1, 4.8]) {
	const [single, double] = heights
	const lines = []
	let current = top
	this.add = ([link, label = ""], multi = false) => { 
		const params = "?badge=0&autopause=0&quality_selector=1&progress_bar=1&player_id=0&app_id=58479"
		lines.push({
			top: `${current}%`,
			left: `${left}%`,
			modal: <VimeoFrame wrapperStyle={{ backgroundColor: "rgb(59, 80, 206)" }} vidId={link.replace(/^\//, "") + params} />,
			width: `${width}%`,
			height: `${multi ? double : single}%`,
			label
		})

		current += multi ? double : single

		return this
	}

	this.get = () => {
		return lines;
	}

	return this
}

const background = () => {
	const now = new Date()
	if (now < new Date("2023-10-24 08:00:00+0200")) return "https://assets.swoogo.com/uploads/full/3075566-65319dcdc77a6.png" // Day One
	else if (now < auditoriumCloseDate) return "https://assets.swoogo.com/uploads/full/3075567-65319dce16100.png" // Day Two
	else return "https://assets.swoogo.com/uploads/full/3074364-653171c6f2ba5.png" // Day Three
}

export default {
	background: background(), // In case that doesn't work, put the URL here
	links: [
		...( new Date() >= new Date("2023-10-22 08:00:00+0200") ? new column(6.1)
			.add(["/875128706", "B1.1 Diary of a CISO: A celebration of success - and the odd tailure - in my Tirst vear al outokumpu"], true)
			.add(["/875086771", "BI.2 Leveraging risk-based protection to navigate the challenges o digicalisation"], true)
			.add(["/875089515", "BI.3 Using the IS SOGP to guide control implementation and security assurance"], true)
			.add(["/875091662", "B1.4 That's SOOO unfair! .. or is it? Towards a better understanding of AI trustworthiness"], true)
			.add(["/875202990", "B1.5 KPMG: Fast bytes, Furious Fixes: conquering OT security challenges in style"], true)
			.add(["/875093768", "B2.1 Security as a business enabler (or is it?)"])
			.add(["/875213450", "B2.2 Serious Games. a tool for security awareness training"])
			.add(["/875101765", "B2.3 An OT Sec Programme - Where do I start?"])
			.add(["/875103786", "B2.4 Pearls and Perils of Sectoral Cooperation"])
			.add(["/875202108", "B2.5 BlueVovant: Converging Internal and External Cyber Defence to build resiliency"], true)
			.add(["/875105816", "B3.1 Aikido and the intinite mindset: continuous evolution in securit leadershin"], true)
			.add(["/875120342", "B3.2 A Security Odvssey: An adventure into uncharted waters"])
			.add(["/875112909", "B3.3 Risk Based Strateav: Secure business enablement through true prioritisation"], true)
			.add(["/875122466", "B3.4 Untrusted Eyecution: Attacking the Software Subolv Chain"])
			.add(["/875202185", "B3.5 SureCloud: Dvnamic information securitv through a risk management lens"], true)
			.add(["/875131687", "B4.1 Translating cybersecurity metrics into meaningful reporting"])
			.add(["/875546429", "B4.2 Into security awareness and bevond"])
			.add(["/875546403", "B4.3 Taking Risk: A deep dive for risk management aficionados"])
			.add(["/875131735", "B4.4 Improving supplier assurance with the Software Bill of Materials: How to get ready for the European Cyber Resilience Act"], true)
			.add(["/875202260", "B4.5 Noetic Cyber: The Over Exposure Problem: New approaches to managing your Attack Surface"], true)
			.get() : []),
		...( new Date() >= new Date("2023-10-24 08:00:00+0200") ? 
			new column(36, 8, 34.5)
				.add(["/875219968", "B5.1 Help, we do not have a CISO! Long live information security"])
				.add(["/875126885", "B5.2 Mitigating Risk by Automating Controls in public cloud to empower your organisation"])
				.add(["/875130502", "B5.3 From education to culture: How to effectivelv drive security culture change"])
				.add(["/875132368", "B5.4 A Welcome home - we've been waiting Tor you"])
				.add(["/875202303", "B5.5 IBM Security: The journey to quantum safe"])
				.add(["/875123726", "B6.1 Beyond a licence to operate: Making security a competitive advantage"])
				.add(["/875125405", "B6.2 Placing empathy at the heart of human cvber risk reduction at Canadian Tire Corporation"], true)
				.add(["/875126988", "B6.3 Future proofing your crypto assets in a post quantum world"])
				.add(["/875128858", "B6.4 Cvber Resilience: Enhancing Risk Assessments with MITRE ATT&CK and ISF Tools"])
				.add(["/875207628", "B6.5 Huawei: How vour vendor can support vou to be ready for NIS2"])
				.add(["/875150293", "B7.1 Quality security: Taking security beyond the basics"])
				.add(["/875148316", "B7.3 From guesswork to precision Tackling the challenges of cyber risk guantification"])
				.add(["/875202385", "B7.5 SecuritScorecard: Discover the power of cyber risk ratinas for legal compliance"])
				.add(["/875146549", "B8.1 The journey from awareness to accountability among all employees"])
				.add(["/875546334", "B8.2 Mind the gap! Developing the next generation of information security professionals"])
				.add(["/875546113", "B8.4 IT/OT Architecture Governance & Corporate Politics: A survival guide for the wary CI(S)O"])
				.add(["/875202437", "B8.5 CrowdStrike: Long live the SOC: A new blueprint for tomorrow's threats"])
				.get() 
		: []),
		...( new Date() >= auditoriumCloseDate ? 
			new column(72, 8, 22, [3.8, 5])
				.add(["/875143590", "B9.1 From media to manager: Making security central to enterprise strategy"], true)
				.add(["/875145526", "B9.3 Managing External Auditors: Lessons from the front line"], true)
				.add(["/875153693", "B9.4 Extending traditional penetration testing with bug bounties"], true)
				.add(["/875202481", "B9.5 ReversingLabs: Verity trust in commercial software"])
				.add(["/875142097", "B10.2 Is product security the next frontier in information security?"], true)
				.add(["/875143753", "B10.3 Empowering cybersecurity risk management: The implementation of AOL EDGE"], true)
				.get() 
		: []),
		{
			top: `92.6%`,
			left: `42.6%`,
			href: "/atrium",
			width: `14.7%`,
			height: `6%`,
			label: "Back to Atrium"
		}
	]
	,
	name: "breakout",
}